module.exports = __webpack_public_path__ + "img/131.aeea4e37.jpg";